module.exports = __webpack_public_path__ + "media/video.c7df2e7f.mp4";